import React from "react";
import { useSmoothScroll } from "../../hooks/useSmoothScroll";
import logoImg from "../../assets/figma/page13/nav_logo.png";

export function NavbarLogo() {
  const smoothScroll = useSmoothScroll();

  return (
    <a
      className="nav__logo"
      href="#inicio"
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => smoothScroll(e, "#inicio")}
      aria-label="Voltar ao início"
    >
      <img 
        src={logoImg} 
        alt="Cris Morais - Arquitetura" 
        className="nav__logo-img"
      />
    </a>
  );
}